module.exports = __webpack_public_path__ + "static/media/Elaine_Dunphy.790f2b4e.webp";